import React from "react";
import Head from "next/head";
import { WEBPAGE_TITLE } from "@utils/Constants";
import CompaniesSection from "@components/CompaniesSection/CompaniesSection";
import { useTranslations } from "next-intl";
import { useInView } from "@hooks/useInView";
import styles from "./CustomersPage.module.scss";

const CustomersPage = () => {
    const t = useTranslations("CustomersPage");
    const [totalCount, setTotalCount] = React.useState(0);

    const [heroRef, heroInView] = useInView();
    const [companiesRef, companiesInView] = useInView();
    const [ctaRef, ctaInView] = useInView();

    return (
        <>
            <Head>
                <title key="site_title">
                    {WEBPAGE_TITLE + " - Stafrænn sjálfbærnivettvangur"}
                </title>
                <meta
                    property="og:title"
                    content={`${WEBPAGE_TITLE} - Stafrænn sjálfbærnivettvangur`}
                    key="og:title"
                />
            </Head>
            <div className={styles.pageWrapper}>
                <div
                    ref={heroRef}
                    className={`${styles.hero} ${styles.revealTarget} ${heroInView ? styles.revealed : ""}`}
                >
                    <div className={styles.heroContent}>
                        <h1 className={styles.heroTitle}>
                            {t("who_is_in_Leaf")}
                        </h1>
                        <p className={styles.heroSubtitle}>
                            {t("customers_subtitle")}
                            {totalCount > 0 && (
                                <span className={styles.heroBadge}>
                                    {totalCount}
                                </span>
                            )}
                        </p>
                    </div>
                    <div className={styles.heroLine} />
                </div>
                <div
                    ref={companiesRef}
                    className={`${styles.revealTarget} ${companiesInView ? styles.revealed : ""}`}
                    style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <CompaniesSection onTotalCountChange={setTotalCount} />
                </div>
                <div
                    ref={ctaRef}
                    className={`${styles.ctaSection} ${styles.revealTarget} ${ctaInView ? styles.revealed : ""}`}
                >
                    <div className={styles.ctaCard}>
                        <div className={styles.ctaLine} />
                        <div className={styles.ctaContent}>
                            <h3 className={styles.ctaTitle}>
                                {t("cta_title")}
                            </h3>
                            <p className={styles.ctaSubtitle}>
                                {t("cta_subtitle")}
                            </p>
                            <a
                                href="https://admin.laufid.is/registration"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.ctaButton}
                            >
                                {t("cta_button")}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CustomersPage;
